// src/App.js
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AppChat from "./chat-ui/AppChat";
import Login from "./chat-ui/components/Login";
import Register from "./chat-ui/components/Register";
import DailyActiveUsersChart from "./chat-ui/components/DailyActiveUsersChart";
import OcrUsageDashboard from "./chat-ui/components/OcrUsageDashboard";
import AdminFeedbackList from "./chat-ui/components/AdminFeedbackList";
import { AuthProvider } from "./auth/AuthContext";
import RequireAuth from "./auth/RequireAuth";

function App() {
  const isDev = process.env.NODE_ENV !== "production";
  const devPathBase = "/aihub-dev";
  const routerBasename = isDev
    ? (window.location.pathname.startsWith(devPathBase) ? devPathBase : "/")
    : (process.env.PUBLIC_URL || "/");
  return (
    <AuthProvider>
      <Router basename={routerBasename}>
        <Routes>
          {/* ✅ Route ที่ไม่ต้อง login */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* ✅ Route ที่ต้อง login */}
          <Route element={<RequireAuth />}>
            <Route path="/" element={<AppChat />} />
            <Route path="/c/:cid" element={<AppChat />} />
            <Route path="/admin/active-users" element={<DailyActiveUsersChart />} />
            <Route path="/admin/ocr-usage" element={<OcrUsageDashboard />} />
            <Route path="/admin/feedback" element={<AdminFeedbackList />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
